import { OnDestroy, Pipe, PipeTransform } from '@angular/core';

/**
 * Renders a Blob as an object URL for img/video src. Memoizes by blob so change
 * detection reuses one URL, and revokes them when the view is destroyed.
 */
@Pipe({
    name: 'blobUrl',
})
export class BlobUrlPipe implements PipeTransform, OnDestroy {
    private readonly urls = new Map<Blob, string>();

    transform(blob: Blob | null | undefined): string | null {
        if (!blob) {
            return null;
        }

        const existing = this.urls.get(blob);
        if (existing) {
            return existing;
        }

        const url = URL.createObjectURL(blob);
        this.urls.set(blob, url);
        return url;
    }

    ngOnDestroy(): void {
        this.urls.forEach((url) => URL.revokeObjectURL(url));
        this.urls.clear();
    }
}
